// 3-tone ascending square-wave alert via Web Audio API.
// Browsers block audio until first user interaction, so we keep a singleton
// AudioContext lazily created and resumed on click/keydown.

let ctx: AudioContext | null = null;
let unlocked = false;

function ensureContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (!ctx) {
    const AC = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
}

export function unlockAudio() {
  if (unlocked) return;
  const c = ensureContext();
  if (!c) return;
  void c.resume();
  unlocked = true;
}

export function playOtpAlert() {
  const c = ensureContext();
  if (!c || c.state !== 'running') return;

  // 3 ascending square-wave tones: 880, 1108.7, 1318.5 (A5 → C#6 → E6 — A major triad)
  const tones = [880, 1108.7, 1318.5];
  const now = c.currentTime;
  const dur = 0.16;
  const gap = 0.04;

  tones.forEach((freq, i) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = 'square';
    osc.frequency.value = freq;
    const start = now + i * (dur + gap);
    gain.gain.setValueAtTime(0, start);
    gain.gain.linearRampToValueAtTime(0.18, start + 0.02);
    gain.gain.setValueAtTime(0.18, start + dur - 0.04);
    gain.gain.linearRampToValueAtTime(0, start + dur);
    osc.connect(gain);
    gain.connect(c.destination);
    osc.start(start);
    osc.stop(start + dur + 0.02);
  });
}
